import React, { useState, useEffect } from 'react'
import { firestore } from '../../../firebase'

function AddMainCategory({mainCategory, setMainCategory}) {

    const [categories, setCategories] = useState([])

    useEffect(() => {

        try {
            const categoriesRef = firestore.collection("recipeCategories");
            categoriesRef.onSnapshot(({docs}) => {
                const categories = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setCategories(categories)
            })
        } catch (error) {
            
        }

    }, [])


    return (
        <div>
            <label>Velg kategori</label>
            <select className="browser-default custom-select" onChange={e => setMainCategory(e.target.value)}>
                <option value="">Velg kategori</option>
                {categories && categories.map((category, index) => {
                    return (                     
                        <option key={index} selected={category.id === mainCategory} value={category.id}>{category.category}</option>       
                    )
                })}
            </select>
                        
        </div>
    )

}
export default AddMainCategory